import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Image, Popconfirm, Spin } from "antd";
import { useState } from "react";
import { EUserRole } from "@devowl-wp/api-real-cookie-banner";
import { useStores } from "../../../../../store/root.js";
const ImageWithButtons = (props)=>{
    const { rcbAuthenticationStore } = useStores();
    const { deleteOptions, isBusy, ...rest } = props;
    const { onDelete } = deleteOptions;
    const [hiddenButtons, setHiddenButtons] = useState(true);
    const handleMouseEnter = (isEntered)=>{
        setHiddenButtons(isEntered);
    };
    return /*#__PURE__*/ _jsxs("span", {
        style: {
            position: "relative",
            display: "inline-flex"
        },
        onMouseEnter: ()=>{
            handleMouseEnter(false);
        },
        onMouseLeave: ()=>{
            handleMouseEnter(true);
        },
        children: [
            /*#__PURE__*/ _jsx(Spin, {
                spinning: isBusy,
                children: /*#__PURE__*/ _jsx(Image, {
                    ...rest
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                hidden: hiddenButtons || !rcbAuthenticationStore.hasRole(EUserRole.Admin) || isBusy,
                children: /*#__PURE__*/ _jsx("div", {
                    hidden: !onDelete,
                    children: /*#__PURE__*/ _jsx(Popconfirm, {
                        title: "Are you sure to delete this image?",
                        onConfirm: ()=>onDelete?.(props.media),
                        okText: "Yes",
                        cancelText: "No",
                        children: /*#__PURE__*/ _jsx(Button, {
                            icon: /*#__PURE__*/ _jsx(DeleteOutlined, {}),
                            style: {
                                position: "absolute",
                                right: "0.3rem",
                                bottom: "0.3rem"
                            }
                        })
                    })
                })
            })
        ]
    });
};
export { ImageWithButtons };
